import { onMounted, computed, watch, ref } from 'vue'
import { useStore } from 'vuex'
import LinkArrow from 'src/pages/dashboard/icons/link-arrow'
import EditIcon from 'src/pages/bundle-submission/components/icons/edit-icon/index.vue'
import PercentageStar from 'src/pages/dashboard/icons/percentage-star'
import Misc from 'src/utils/helper/misc.js'
import i18n from 'src/assets/i18n/i18n.js'
import { VIEW_PROMOTION, NEW_PROMOTION, PROMOTION_DASHBAORD } from 'src/utils/constants/app-routes-name'
import { useRouter } from 'vue-router'
import isEmpty from 'lodash/isEmpty'
import { MdButton, MdIconArrowLong } from '@antiqua-dls/vue-components'

import { adobeCjaEventEmitter } from '../../../../../../modules/adobe-cja/utils'
import { CJA_EVENTS, LINK_CATEGORIES, LINK_SECTION, LINK_NAMES, LINK_TYPES } from '../../../../../../modules/adobe-cja/constants'
export default{
  components:{
    LinkArrow,
    EditIcon,
    PercentageStar,
    MdButton,
    MdIconArrowLong
  },
  setup(){

    const store = useStore()
    const router = useRouter()
    
    const lang = i18n()
    const showPromotion = ref(false)
    
    const currentFoundryName = computed(() => store.getters['profile/sessionFoundryName'])
    const foundriesList = computed(() => store.getters['profile/foundries'])
    const sessionFoundryId = computed(() => store.getters['profile/sessionFoundryId'])
    
    const promotionList = computed(() => {
      const promotionData = store.getters['promotions/promotionsList']
      if (!isEmpty(promotionData)) {
        return promotionData.map(promotion => {
          if (!Misc.isFutureDate(promotion.endDate)){
            promotion.modifiedDate = 'today'
          }else{
            promotion.modifiedDate = Misc.formattedDateFromNow(promotion.endDate, lang.locale, 'YYYYMMDD')
          }
          return { ...promotion }
        })
      }
      return false
    })
    
    const hasPromotionPermission = computed(() => {
      return Misc.foundryHasModulePermission('promotions', foundriesList.value, sessionFoundryId.value)
    })
    
    const gotoPromotionPages = (pageName, promotionId) => {
      const routeData = {
        name: pageName,
        params: {}
      }
      if (!isEmpty(promotionId)) {
        routeData.params.id = promotionId
      }
      if (pageName === NEW_PROMOTION) {
        adobeCjaEventEmitter({
          event: CJA_EVENTS.LINK_CLICK,
          links: {
            linkCategory: LINK_CATEGORIES.CREATE_PROMOTION,
            linkSection: LINK_SECTION.DASHBOARD,
            linkName: LINK_NAMES.CREATE_PROMOTION,
            linkType: LINK_TYPES.BUTTON
          }
        })
      }
      router.push(routeData)
    }

    const handleLearnMoreClick = () => {
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.LEARN_MORE,
          linkSection: LINK_SECTION.PROMOTION_DASHBOARD,
          linkName: LINK_NAMES.LEARN_MORE,
          linkType: LINK_TYPES.BUTTON
        }
      })
      // Open the learn more link in a new tab
      window.open('https://foundrysupport.monotype.com/hc/en-us/articles/360028863331-Create-a-promotion', '_blank', 'noopener');
    }
    const getPromotionList = () => {
      const params = {
        page: 1, 
        perPage: 5, 
        sortBy: 'endDate', 
        sortDirection: 'asc', 
        status: 'active' 
      }
      showPromotion.value = false
      if (hasPromotionPermission.value) {
        store.dispatch('promotions/getPromotions', params)
        showPromotion.value = true
      }
    }
    
    watch(currentFoundryName, () => {
      getPromotionList()
    })
    
    onMounted(() => {
      getPromotionList()
    })
    return{
      promotionList,
      gotoPromotionPages,
      showPromotion,
      VIEW_PROMOTION,
      NEW_PROMOTION,
      PROMOTION_DASHBAORD,
      handleLearnMoreClick
    }
  }
}
